import React, { useState } from "react";
import EventMiniBlk from "../../common/EventMiniBlk";
import JobsEvents from "./Jobs-Event";
import { Link } from "react-router-dom";
import { websiteLink } from "../../../helpers/helpers";
import * as paths from "../../../constants/paths";
import { useSelector } from "react-redux";
import ImageControl from "../../common/ImageControl";
import Breadcrumb from "../../common/BreadCrumb";
const Account = ({
  events,
  saved_jobs,
  applied_jobs,
  applied_job_actions,
  memData,
}) => {
  const breadcrumbItems = [{ name: "Dashboard", link: "/dashboard" }];
  const [jobsType, setJobsTyps] = useState(1);
  // const [jobs, setJobs] = useState(applied_jobs);
  const [popupJob, setPopupJob] = useState(false);
  const PopupJobActive = () => {
    setPopupJob(!popupJob);
  };
  const handleToggleJobs = (param) => {
    setJobsTyps(param);
    // if (param == 1) setJobs(applied_jobs);
    // else setJobs(saved_jobs);
  };
  const dashboard_articles = useSelector(
    (state) => state.fetchSiteSettings.dashboard_articles,
  );
  const guidance_steps = useSelector(
    (state) => state.fetchSiteSettings.guidance_steps,
  );

  const activePlan = useSelector((state) => state.fetchSiteSettings.activePlan);

  const getArticleLink = (dashboard_article) => {
    if (dashboard_article?.link_type === "article") {
      return `${paths.SITE_BASE_URL}/article/${dashboard_article?.encoded_id}/${dashboard_article?.slug}`;
    }
    if (dashboard_article?.link_type === "website_page") {
      const link = dashboard_article?.link || "";
      const planId = parseInt(activePlan?.plan_id);
      const createdDate = activePlan?.created_date?.split(" ")[0];

      // if (link.includes("open-jobs/1?is_global=1")) {
      //   if (!activePlan) {
      //     return `${paths.SITE_BASE_URL}/subscription`;
      //   }
      //   if (![6, 8].includes(parseInt(activePlan?.plan_id))) {
      //     return `${paths.SITE_BASE_URL}/subscription`;
      //   }
      // }

      if (link.includes("open-jobs/1?is_global=1")) {
        if (!activePlan) {
          return `${paths.SITE_BASE_URL}/subscription`;
        }

        const planId = parseInt(activePlan?.plan_id);
        const createdDate = activePlan?.created_date?.split(" ")[0];

        //  Plan 6 & 8 → always allowed
        if ([6, 8].includes(planId)) {
          return `${paths.SITE_BASE_URL}/${link}`;
        }

        //  Plan 5 & 7 → check created_date
        if ([5, 7].includes(planId)) {
          if (createdDate < paths.CHK_EXPLORE_PLAN_DATE) {
            // New subscription → allowed
            return `${paths.SITE_BASE_URL}/${link}`;
          }

          // Old subscription → not allowed
          return `${paths.SITE_BASE_URL}/subscription`;
        }

        // All other plans → not allowed
        return `${paths.SITE_BASE_URL}/subscription`;
      } else if (
        link.includes("learning-hub") ||
        link.includes("cv-generator")
      ) {
        if (!activePlan) {
          return `${paths.SITE_BASE_URL}/subscription`;
        }
        if ([1, 2, 3, 4, 5, 7, 9].includes(Number(activePlan?.plan_id))) {
          return `${paths.SITE_BASE_URL}/subscription`;
        }

        if ([6, 8].includes(Number(activePlan?.plan_id))) {
          return `${paths.SITE_BASE_URL}/${link}`;
        }

        return `${paths.SITE_BASE_URL}/subscription`;
      }
      return `${paths.SITE_BASE_URL}/${link}`;
    }

    if (dashboard_article?.link_type === "external_link") {
      return dashboard_article?.link;
    }

    return "#";
  };

  const getTarget = (dashboard_article) => {
    return dashboard_article?.link_type === "external_link"
      ? "_blank"
      : "_self";
  };

  const guidanceColors = [
    "#eaf2ff",
    "#f3ecff",
    "#fff4e0",
    "#ffeef0",
    "#e8f8f0",
  ];
  const guidanceIcons = ["🧭", "📄", "🧩", "🎤", "🤝"];

  return (
    <>
      <section id="dash">
        {/* <Breadcrumb items={breadcrumbItems} /> */}
        <div className="contain">
          <div className="dash_new_txt text-center">
            <h3>👋 Welcome back, {memData.mem_fname}!</h3>
            <p>Let's find your dream job today.</p>
          </div>
          <div className="outer_cmn_blk_dash mb-5">
            <div className="cmn_blk_new_dash outer_preparation_guid">
              <div className="top_head mb-3">
                <h4 className="heading_dash">Preparation Guidance</h4>
              </div>
              <div className="flex">
                {guidance_steps?.map((guidance_step, index) => {
                  return (
                    <div className="col" key={index}>
                      <div className="inner position-relative">
                        <div className="access_outer_flex">
                          <div
                            className="icon_img"
                            style={{
                              backgroundColor:
                                guidance_step?.bg_color || "#dbeafe",
                            }}
                          >
                            <span>{guidance_step?.emoji || "✨"}</span>
                          </div>

                          <span className="step_num">Step {index + 1}</span>
                          <h5>{guidance_step?.title}</h5>
                        </div>

                        <p>{guidance_step?.short_desc}</p>

                        <div className="btn_blk">
                          <a
                            className="site_btn text"
                            href={`/preparation-guidance-details/${guidance_step?.slug}`}
                          >
                            Read Guide
                            <img src="/images/arrow-right-blue.svg" alt="" />
                          </a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="outer_cmn_blk_dash">
            {dashboard_articles && (
              <div className="cmn_blk_new_dash">
                <div className="top_head mb-3">
                  <h4 className="heading_dash">Quick Access</h4>
                </div>
                <div className="flex">
                  {dashboard_articles?.map((dashboard_article, index) => {
                    return (
                      <div className="col" key={index}>
                        <a
                          href={getArticleLink(dashboard_article)}
                          target={getTarget(dashboard_article)}
                          className="inner"
                        >
                          <div className="access_outer_flex">
                            <div
                              className="icon_img"
                              style={{
                                backgroundColor:
                                  dashboard_article.bg_color || "#dbeafe",
                              }}
                            >
                              <ImageControl
                                folder="images"
                                src={dashboard_article.image}
                              />
                            </div>
                            <h5>{dashboard_article?.title}</h5>
                          </div>
                          <p>{dashboard_article?.short_desc}</p>
                        </a>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            <div className="cmn_blk_new_dash">
              <div className="top_head full_wide_head">
                <h4 className="heading_dash">Registered Events</h4>
                <Link to={paths.events_link}>View all events</Link>
              </div>
              <div className="flex_row event_row row">
                {events.length ? (
                  events.map((event) => {
                    return (
                      <div className="col col-md-4" key={event.id}>
                        <EventMiniBlk event={event} />
                      </div>
                    );
                  })
                ) : (
                  <div className="no_events">
                    <div className="no_data_found">
                      <div className="icon_img">
                        <img
                          src={
                            paths.SITE_BASE_URL + "/images/dash-calendar.svg"
                          }
                          alt="doucment image"
                        />
                      </div>
                      <div className="inner_cntnt">
                        <p>
                          <strong>No Registered Events</strong>
                        </p>
                        <p>Your registered events will show here.</p>
                        <div className="btn_blk text-center">
                          <Link to={paths.events_link} className="site_btn">
                            Register
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {/* =================if data no found===== */}

              {/* <div className="no_data_found">
                <div className="icon_img">
                    <img
                      src="/images/dash-calendar.svg"
                      alt="doucment image"
                    />
                </div>
                <div className="inner_cntnt">
                  <p><strong>No registered webinars</strong></p>
                  <p>Your registered events and webinars will show here.</p>
                  <div className="btn_blk text-center">
                    <Link to="" className="site_btn">Register</Link>
                  </div>
                </div>
              </div> */}

              {/* ==============end data no found====================== */}
            </div>

            {/* <div className="cmn_blk_new_dash">
              <div className="top_head full_wide_head">
                <h4 className="heading_dash">My Jobs</h4>
                <Link to={websiteLink("/open-jobs/1")}>View all jobs</Link>
              </div>
              <div className="top_head jobs_dash_tabs">
                <div className="left_tab">
                  <h4
                    className={jobsType == 1 ? "heading active" : "heading"}
                    onClick={() => handleToggleJobs(1)}
                  >
                    Applied Jobs
                  </h4>
                  <h4
                    className={jobsType == 2 ? "heading active" : "heading"}
                    onClick={() => handleToggleJobs(2)}
                  >
                    Saved Jobs
                  </h4>
                </div>
                <div className="add_job_opt" style={{ display: "none" }}>
                  <span className="site_btn" onClick={() => PopupJobActive()}>
                    Add New Job
                  </span>
                </div>
              </div>

              <JobsEvents
                jobs={jobsType == 1 ? applied_jobs : saved_jobs}
                applied_job_actions={applied_job_actions}
                jobsType={jobsType}
              />
            </div> */}
          </div>
          {/* <div className="top_head mb-3">
            <h4 className="heading_dash">Registered Events</h4>
          </div>
          <div className="flex_row event_row row">
            {events.length ? (
              events.map((event) => {
                return (
                  <div className="col col-md-3" key={event.id}>
                    <EventMiniBlk event={event} />
                  </div>
                );
              })
            ) : (
              <p>The event that you have registered will show here.</p>
            )}
          </div>
          <div className="br"></div>
          <div className="br"></div> */}
          {/* <div className="top_head jobs_dash_tabs">
            <div className="left_tab">
              <h4
                className={jobsType == 1 ? "heading active" : "heading"}
                onClick={() => handleToggleJobs(1)}
              >
                Applied Jobs
              </h4>
              <h4
                className={jobsType == 2 ? "heading active" : "heading"}
                onClick={() => handleToggleJobs(2)}
              >
                Saved Jobs
              </h4>
            </div>
            <div className="add_job_opt" style={{ display: "none" }}>
              <span className="site_btn" onClick={() => PopupJobActive()}>
                Add New Job
              </span>
            </div>
          </div>

          <JobsEvents
            jobs={jobsType == 1 ? applied_jobs : saved_jobs}
            applied_job_actions={applied_job_actions}
            jobsType={jobsType}
          /> */}
        </div>
      </section>

      <div
        className={popupJob ? "popup text_popup active" : "popup text_popup"}
      >
        <div className="table_dv">
          <div className="table_cell">
            <div className="contain">
              <div className="_inner">
                <button
                  type="button"
                  className="x_btn"
                  onClick={() => PopupJobActive()}
                ></button>
                <div className="heading_text">
                  <h4>Add new job</h4>
                  <p>Please fill these fields!</p>
                </div>
                <form action="">
                  <div className="form_row row">
                    <div className="col-sm-12">
                      <h6>Company Name</h6>
                      <div className="form_blk">
                        <input type="text" className="input" />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <h6>Job Title</h6>
                      <div className="form_blk">
                        <input type="text" className="input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <h6>Min Sallery</h6>
                      <div className="form_blk">
                        <input type="text" className="input" />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <h6>Max Sallery</h6>
                      <div className="form_blk">
                        <input type="text" className="input" />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <h6>Job Description</h6>
                      <div className="form_blk">
                        <textarea className="input"></textarea>
                      </div>
                    </div>
                  </div>
                  <div className="br"></div>
                  <div className="btn_blk text-center">
                    <button className="site_btn" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Account;